<ng-container *ngIf="showResults; else nothingFound">
  <ng-container *mojoHasPrivilege="privileges.candidates.view">
    <div
      class="menu-item"
      *ngIf="searchedResults.candidates.length > 0"
    >
      <mojo-user-card
        *ngFor="let candidate of searchedResults.candidates"
        [user]="candidate.sourceCandidate"
        [role]="candidate.currentJobTitle"
        [markedCandidateName]="true"
      >
        <a
          [routerLink]="['', { outlets: { primary: 'candidates/' + candidate.id, modal: null } }]">
          <common-mojo-mark-search-phrase-box
            [markedSearchPhrase]="searchedPhrase"
            [text]="candidate.visibleName"
          >
          </common-mojo-mark-search-phrase-box>
        </a>
        <div class="email">
          {{ candidate.visibleMail }}
        </div>
      </mojo-user-card>
    </div>
  </ng-container>
  <ng-container *mojoHasPrivilege="privileges.job.view">
    <div
      class="menu-item"
      data-cy="global-search-results-job-list"
      *ngIf="searchedResults.jobs.length > 0"
    >
      <a
        *ngFor="let job of searchedResults.jobs"
        [routerLink]="['', { outlets: { primary: 'jobs/job/' + job.id, modal: null } }]"
      >
        <mojo-job-card
          data-cy="global-search-results-job-item"
          [markedSearchPhrase]="searchedPhrase"
          [job]="job"
          [statusFilterType]="jobStatusFilterFeature$ | async"
        >
        </mojo-job-card>
      </a>
      <a
        class="see-all-link"
        (click)="goToSearchPage(searchedPhrase)"
        data-cy="global-search-see-all"
      >SEE ALL
        <span class="material-icons">keyboard_arrow_right</span>
      </a>
    </div>
  </ng-container>
  <ng-container *mojoHasPrivilege="privileges.companies.view">
    <div
      class="menu-item"
      data-cy="global-search-results-company-list"
      *ngIf="searchedResults.companies.length > 0"
    >
      <a
        *ngFor="let company of searchedResults.companies"
        [routerLink]="['', { outlets: { primary: 'companies/' + company.id, modal: null } }]"
      >
        <mojo-company-card
          data-cy="global-search-results-company-item"
          [markedSearchPhrase]="searchedPhrase"
          [company]="company"
        >
        </mojo-company-card>
      </a>
    </div>
  </ng-container>
</ng-container>
<ng-template #nothingFound>
  <span class="pr-4">
    No results found
  </span>
</ng-template>
